import React from 'react';
import { Form, Input, Checkbox } from 'antd';

const InputGroup = Input.Group;

export default function Footer(props) {
    return (
        <div className="row">
            <div className={"col-md-6"}>
                <Form.Item>
                    <InputGroup compact>
                        <Form.Item style={{ width: '33.33%' }}>
                            {/* <Checkbox
                                checked={props.formValues.flagExportacion}
                            >
                                Exportación
                            </Checkbox> */}
                        </Form.Item>
                        <Form.Item style={{ width: '33.33%' }}>
                            {/* <Checkbox
                                checked={props.formValues.flagPercepcion}
                            >
                                Percepción
                            </Checkbox> */}
                        </Form.Item>
                        <Form.Item style={{ width: '33.33%' }}>
                            {/* <Checkbox
                                checked={props.formValues.flagDetraccion}
                            >
                                Detracción
                            </Checkbox> */}
                        </Form.Item>
                    </InputGroup>
                </Form.Item>
            </div>
            <div className="col-md-3 form-group">
                <Form.Item label='' style={{ display: props.formValues.flagDetraccion ? '' : 'none' }}>
                    {/* <Input readOnly
                        value={props.formValues.nombreDetraccion}
                    /> */}
                </Form.Item>
            </div>
            <div className="col-md-3 pt-10">
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Interes</label>
                        <div>{props.formValues.totalInteres.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Detalle</label>
                        <div>{props.formValues.totalDetalle.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Importe Descuento</label>
                        <div>{props.formValues.importeDescuento.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Sub Total</label>
                        <div>{props.formValues.subTotal.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>IGV</label>
                        <div>{props.formValues.igv.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>ISC</label>
                        <div>{props.formValues.isc.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.formValues.total.toFixed(2)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}